/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash/cloneDeep';

/**
 * Non-destructive array -> array sort based on configuration.
 * @param {
 *  arrayToOrder - The array to order
 *  configuration - Configured order
 *  propToCheck - property on which ordering will be performed
 * } options
 */
export const orderArrayByConfiguration = ({
  arrayToOrder = [],
  configuration = [],
  propToCheck = '',
}) => {
  if (configuration.length === 0) return arrayToOrder;

  const ordered = [];
  const source = cloneDeep(arrayToOrder);

  configuration.forEach((configKey) => {
    const sourceIndex = source.findIndex((x) => x[propToCheck] === configKey);
    if (sourceIndex >= 0) {
      ordered.push(source[sourceIndex]);
      source.splice(sourceIndex, 1);
    }
  });

  return [...ordered, ...source];
};
